import React, { useState, useRef } from 'react';

import calendarIcon from 'assets/img/icons/calendar.svg';

import 'react-datepicker/dist/react-datepicker.css';

import {
  Content,
  ContentText,
  InputContainer,
  ContentInput,
  ImageInput,
  BackButton,
} from './styles';

import { datePickHeader } from './DatePickerHeader';

const DateStep = ({
  schedulingDate,
  setSchedulingDate,
  setStep,
  taskDetailResponsibilitId,
  useBillingCompanyInfo,
}) => {
  const formatDate = date => new Date(date).toLocaleDateString('pt-BR');

  const refDate = useRef(null);

  const [dateSelected, setDateSelected] = useState(new Date());
  const [date, setDate] = useState(schedulingDate);

  const handleIcon = () => {
    refDate.current.setFocus(true);
  };

  const updateDate = (selectedDate) => {
    setDateSelected(selectedDate);
    setDate(selectedDate);
    setSchedulingDate(selectedDate);
  };

  return (
    <Content>
      {taskDetailResponsibilitId === 2 && !useBillingCompanyInfo && (
        <BackButton onClick={() => setStep(1)}>ALTERAR INFORMAÇÕES DE PAGAMENTO</BackButton>
      )}
      <ContentText marginTop={40}>
        Para qual dia você combinou a realização do serviço com o profissional?
      </ContentText>
      <ContentText textAlign="start" marginTop={40} marginLeft={20}>
        Data combinada:
      </ContentText>
      <InputContainer>
        <ContentInput
          renderCustomHeader={datePickHeader}
          minDate={new Date()}
          selected={date ? new Date(date) : dateSelected}
          ref={refDate}
          name="date"
          value={date ? formatDate(date) : new Date().toLocaleDateString('pt-BR')}
          onChange={updateDate}
        />
        <ImageInput src={calendarIcon} onClick={handleIcon} />
      </InputContainer>
    </Content>
  );
};

export default DateStep;
